import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Spinner } from '@carvana/helios-decoration';

const SpinnerWrapper = styled.div`
  align-items: center;
  animation: rotation 1s linear infinite;
  display: flex;
  justify-content: center;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

type useLoadingSpinnerOptions = {
  isLoading?: boolean;
  loadingDelay?: number;
};

const useLoadingSpinner = ({
  isLoading = true,
  loadingDelay = 1
}: useLoadingSpinnerOptions = {}) => {
  const [shouldShowLoadingSpinner, setShouldShowLoadingSpinner] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      return () => {};
    }
    const timeout = window.setTimeout(() => setShouldShowLoadingSpinner(true), loadingDelay);
    return () => window.clearTimeout(timeout);
  }, [isLoading, loadingDelay]);

  return () =>
    shouldShowLoadingSpinner && (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    );
};

export default useLoadingSpinner;
